export const GET_DD_PRODUCTS_TO_MAP_START = 'GET_DD_PRODUCTS_TO_MAP_START';
export const GET_DD_PRODUCTS_TO_MAP_SUCCESS = 'GET_DD_PRODUCTS_TO_MAP_SUCCESS';
export const GET_DD_PRODUCTS_TO_MAP_FAILED = 'GET_DD_PRODUCTS_TO_MAP_FAILED';


export const getDDProductsToMapStart = () => ({
  type: GET_DD_PRODUCTS_TO_MAP_START,
});

export const getDDProductsToMapSuccess = (data) => ({
  type: GET_DD_PRODUCTS_TO_MAP_SUCCESS,
  data
});

export const getDDProductsToMapFailed = (error) => ({
  type: GET_DD_PRODUCTS_TO_MAP_FAILED,
  error
});
